var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBankAccount(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2245_4367)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.8975 6.49951H1.7835V15.4995L0.583496 26.499H28.983L27.783 15.4995V6.49951H1.8975Z",
    fill: "#e5fff2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.589509 26.499L0.51001 27.3L0.597009 26.499H0.589509Z",
    fill: "#e5fff2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9905 26.499L29.0775 27.3L28.9905 26.499Z",
    fill: "#008056"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.509978 27.3015C0.482092 27.5796 0.512815 27.8604 0.600166 28.1259C0.687516 28.3914 0.829553 28.6356 1.01711 28.8428C1.20467 29.05 1.43358 29.2156 1.68908 29.3289C1.94458 29.4422 2.22099 29.5006 2.50048 29.5005H27.0795C27.359 29.5006 27.6354 29.4422 27.8909 29.3289C28.1464 29.2156 28.3753 29.05 28.5628 28.8428C28.7504 28.6356 28.8924 28.3914 28.9798 28.1259C29.0671 27.8604 29.0979 27.5796 29.07 27.3015L28.983 26.5005H0.596977L0.509978 27.3015Z",
    fill: "#008056"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7889 6.49951V2.49901C27.7889 1.96949 27.5789 1.46159 27.2049 1.08674C26.8309 0.711891 26.3235 0.500703 25.7939 0.499512H3.78895C3.25943 0.500703 2.752 0.711891 2.37799 1.08674C2.00399 1.46159 1.79394 1.96949 1.79395 2.49901V6.49951H27.7889Z",
    fill: "#e5fff5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.29004 9H7.29004V10.0005H4.29004V9Z",
    fill: "#008056"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7896 9H13.7896V10.0005H10.7896V9Z",
    fill: "#008056"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2905 9H19.791V10.0005H17.2905V9Z",
    fill: "#008056"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7896 9H25.7896V10.0005H22.7896V9Z",
    fill: "#008056"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.29004 11.5005H7.29004V12.501H4.29004V11.5005Z",
    fill: "#008056"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7896 11.5005H13.7896V12.501H10.7896V11.5005Z",
    fill: "#008056"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2905 11.5005H19.791V12.501H17.2905V11.5005Z",
    fill: "#008056"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7896 11.5005H25.7896V12.501H22.7896V11.5005Z",
    fill: "#008056"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9865 22.0005C14.8541 22.0001 14.7273 21.9473 14.6337 21.8537C14.5401 21.7601 14.4874 21.6333 14.487 21.501H13.4865C13.4877 21.8103 13.5845 22.1116 13.7636 22.3637C13.9427 22.6159 14.1953 22.8065 14.487 22.9095V23.5005H15.4874V22.908C15.7791 22.805 16.0318 22.6144 16.2109 22.3623C16.39 22.1101 16.4867 21.8087 16.488 21.4995C16.4877 21.4335 16.4743 21.3682 16.4485 21.3074C16.4228 21.2467 16.3852 21.1916 16.338 21.1455L14.5155 19.323C14.5557 19.2122 14.6338 19.1191 14.7361 19.0604C14.8383 19.0016 14.958 18.9809 15.074 19.0019C15.19 19.0229 15.2949 19.0843 15.37 19.1752C15.4451 19.2661 15.4856 19.3806 15.4845 19.4985H16.485C16.4837 19.1892 16.387 18.8879 16.2079 18.6357C16.0288 18.3836 15.7761 18.193 15.4845 18.09V17.5005H14.487V18.093C14.1953 18.196 13.9427 18.3866 13.7636 18.6387C13.5845 18.8909 13.4877 19.1922 13.4865 19.5015C13.4868 19.5675 13.5003 19.6327 13.526 19.6935C13.5518 19.7543 13.5893 19.8093 13.6365 19.8555L15.459 21.678C15.4223 21.7734 15.3575 21.8554 15.2731 21.9131C15.1887 21.9707 15.0887 22.0012 14.9865 22.0005Z",
    fill: "#008056"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4855 19.0005H25.485V20.001H20.4855V19.0005Z",
    fill: "#008056"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.985 22.0005H26.4855V23.001H20.985V22.0005Z",
    fill: "#008056"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.48645 19.0005H9.48595V20.001H4.48645V19.0005Z",
    fill: "#008056"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.48596 22.0005H8.98646V23.001H3.48596V22.0005Z",
    fill: "#008056"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7905 1.99951H25.791V3.99901H24.7905V1.99951Z",
    fill: "#008056"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7896 1.99951H23.7901V3.99901H22.7896V1.99951Z",
    fill: "#008056"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.79 1.99951H21.7905V3.99901H20.79V1.99951Z",
    fill: "#008056"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7905 1.99951H19.791V3.99901H18.7905V1.99951Z",
    fill: "#008056"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.29004 1.99951H6.28954V3.00001H4.29004V1.99951Z",
    fill: "#008056"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.29004 4.00049H8.79004V5.00099H4.29004V4.00049Z",
    fill: "#008056"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7895 0H3.7905C3.12757 0.000793929 2.49202 0.264494 2.02326 0.733256C1.55449 1.20202 1.29079 1.83757 1.29 2.5005V15.474L0.1035 26.415C0.1035 26.4285 0.0944999 26.439 0.0929999 26.451L0.0134999 27.252C-0.021058 27.5994 0.0175238 27.9502 0.126761 28.2818C0.235999 28.6135 0.413471 28.9185 0.64775 29.1774C0.88203 29.4363 1.16792 29.6432 1.48702 29.7849C1.80613 29.9265 2.15136 29.9998 2.5005 30H27.0795C27.4289 30.0001 27.7744 29.9269 28.0938 29.7852C28.4132 29.6435 28.6994 29.4365 28.9338 29.1774C29.1683 28.9184 29.3459 28.6131 29.4551 28.2812C29.5643 27.9493 29.6028 27.5982 29.568 27.2505L29.4885 26.4495C29.4885 26.436 29.4795 26.4255 29.478 26.412L28.2915 15.4725V2.5005C28.2907 1.83731 28.0268 1.20153 27.5577 0.732727C27.0886 0.263921 26.4527 0.000396882 25.7895 0V0ZM2.238 16.0005H27.3405L28.425 26.001H1.1535L2.238 16.0005ZM2.289 7.0005H27.2895V15H2.2905V7.0005H2.289ZM3.789 1.0005H25.7895C26.1873 1.0005 26.5689 1.15854 26.8502 1.43984C27.1315 1.72114 27.2895 2.10268 27.2895 2.5005V6H2.2905V2.5005C2.2905 2.10268 2.44853 1.72114 2.72984 1.43984C3.01114 1.15854 3.39268 1.0005 3.7905 1.0005H3.789ZM2.499 29.001C2.28937 29.001 2.08206 28.9571 1.89045 28.872C1.69884 28.787 1.52719 28.6627 1.38656 28.5072C1.24593 28.3518 1.13945 28.1685 1.07399 27.9694C1.00853 27.7702 0.985536 27.5596 1.0065 27.351L1.0455 27H28.5345L28.572 27.351C28.593 27.5596 28.57 27.7702 28.5045 27.9694C28.439 28.1685 28.3326 28.3518 28.1919 28.5072C28.0513 28.6627 27.8797 28.787 27.688 28.872C27.4964 28.9571 27.2891 29.001 27.0795 29.001H2.499Z",
    fill: "#008056"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2245_4367"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29.58,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankAccount);
export default __webpack_public_path__ + "static/media/bank-account.1fa3896856254d2b9422da318d2694d7.svg";
export { ForwardRef as ReactComponent };